module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-mobile.83ae0ac3.svg";